export default "__VITE_ASSET__DBMGcFyA__"